import { render, staticRenderFns } from "./IcoSkillsDomainMoney.vue?vue&type=template&id=573e4ad4"
import script from "./IcoSkillsDomainMoney.vue?vue&type=script&lang=js"
export * from "./IcoSkillsDomainMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports